// extracted by mini-css-extract-plugin
export default {"root":"DataCard_root__LXUh+","rootBgGrey":"DataCard_rootBgGrey__kFc1Y","rootTypeFullText":"DataCard_rootTypeFullText__vHNIL"};